/* Brille Brille：商品說明影片進到畫面才載入、播放，離開畫面暫停（省手機流量）。
   <video data-bb-lazy data-src="..." poster="..." muted loop playsinline preload="none">
   使用者設定「減少動態效果」時不自動播放，改顯示播放鍵。 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function load(v) { if (v.dataset.src && !v.getAttribute('src')) { v.setAttribute('src', v.dataset.src); } }
  function play(v) { load(v); if (reduce) { v.controls = true; return; } var p = v.play(); if (p && p.catch) p.catch(function () { v.controls = true; }); }
  function init() {
    var vs = [].slice.call(document.querySelectorAll('video[data-bb-lazy]'));
    if (!vs.length) return;
    if (!('IntersectionObserver' in window)) { vs.forEach(play); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) play(e.target); else if (!e.target.paused) e.target.pause(); });
    }, { rootMargin: '200px 0px' });
    vs.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
